import { doc, writeBatch } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageModuleDataToUpdate } from "../types";

type Data = {
  [moduleId: string]: PageModuleDataToUpdate;
};

export const bulkUpdateModulesByBrandPage = async (
  brandId: string,
  pageId: string,
  data: Data,
): Promise<void> => {
  const batch = writeBatch(db);

  Object.entries(data).forEach(([moduleId, moduleData]) => {
    const docRef = doc(
      db,
      `brands/${brandId}/pages/${pageId}/modules/${moduleId}`,
    );
    batch.update(docRef, moduleData);
  });

  await batch.commit();
};
